import { render, staticRenderFns } from "./PopupRiskAssessment.vue?vue&type=template&id=4f9cb161"
import script from "./PopupRiskAssessment.vue?vue&type=script&lang=js"
export * from "./PopupRiskAssessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports